var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCubes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2190",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2202"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2196",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2200",
    clipPath: "url(#clipPath2204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2206",
    transform: "translate(496,236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -120,-40 V -221 L 0,-181 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2208"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2210",
    transform: "translate(256,236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 120,-40 V -221 L 0,-181 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2212"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2214",
    transform: "translate(496,236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -120,-40 -240,0 -120,40 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2216"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2218",
    transform: "translate(256,236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -120,-40 V -221 L 0,-181 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2220"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2222",
    transform: "translate(16,236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 120,-40 V -221 L 0,-181 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2224"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2226",
    transform: "translate(256,236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -120,-40 -240,0 -120,40 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2228"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2230",
    transform: "translate(376,457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -120,-40 V -221 L 0,-181 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2232"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2234",
    transform: "translate(136,457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 120,-40 V -221 L 0,-181 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2236"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2238",
    transform: "translate(376,457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -120,-40 -240,0 -120,40 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2240"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubes);
export default __webpack_public_path__ + "static/media/cubes.246e697facfc64a1612bf59cfe4b0616.svg";
export { ForwardRef as ReactComponent };